import { generatePsetContent } from '../../data/apis/api';
import { useRestMutation } from '../../data/util';
import { useImportState } from './Import/useImportState';

export const usePsetContentMutation = (path: string) => {
  const {
    transpilerState: { transpilerId }
  } = useImportState();
  return useRestMutation(() => generatePsetContent(transpilerId, path), {
    retry: false,
    sentryTag: 'transpiler.psetContentUI'
  });
};
